import clsx from "clsx";
import { useId } from "react";

function TextField({ label, value, onChange, suffix, error, disabled, id, className, labelClassName, inputClassName, ...input }) {
  const auto = useId();
  const inputId = id || `tf-${auto}`;
  const errorId = `${inputId}-error`;
  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className={labelClassName || "mb-1 block text-sm text-text-muted"}>
          {label}
        </label>
      )}
      <div
        data-testid="textfield-frame"
        className={clsx("flex items-center gap-2 rounded-lg border bg-surface px-3 py-2", error ? "border-danger-border" : "border-border", disabled && "bg-surface-alt")}>
        <input
          {...input}
          id={inputId}
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? errorId : undefined}
          className={clsx("min-w-0 flex-1 bg-transparent text-text outline-none", inputClassName)}
        />
        {suffix && (
          <span data-testid="textfield-suffix" className="text-text-muted">
            {suffix}
          </span>
        )}
      </div>
      {error && (
        <p id={errorId} className="mt-1 text-xs text-danger">
          {error}
        </p>
      )}
    </div>
  );
}

export default TextField;
